<script setup lang="ts">
import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits(["update:modelValue", "change"]);

const props = withDefaults(
  defineProps<{
    id: string;
    options: { option: string; value: string | number | boolean }[];
    width?: string;
    value?: string | number | null;
  }>(),
  {
    width: "100%",
  }
);

const internalValue = ref<string | number | null>(null);

function update() {
  emit("update:modelValue", internalValue.value);
  emit("change", internalValue.value);
}

function checkNull(event: Event) {
  if (String(internalValue.value) === String(event.target?.value)) {
    internalValue.value = null;
    update();
  }
}

watchEffect(() => {
  if (props.value) internalValue.value = props.value;
});
</script>

<template>
  <div class="base-radio">
    <div v-if="$slots.label" class="label">
      <slot name="label" />
    </div>
    <div class="options">
      <template v-for="(item, index) in options" :key="index">
        <div class="option">
          <input
            v-model="internalValue"
            type="radio"
            :name="id"
            :id="`${id}${index}`"
            :value="item.value"
            @change="update()"
            @click="checkNull"
          />
          <label :for="`${id}${index}`">{{ item.option }}</label>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$width: v-bind("width");

.base-radio {
  display: flex;
  flex-direction: column;
  width: $width;
  gap: 0.25rem;

  .label {
    font-size: 0.875rem;
    margin-block-end: 0.2rem;
    // margin-inline: 0.5rem;
  }

  .options {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .option {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.25rem;
        margin-inline: 0.25rem;

        input {
            width: 1rem;
            height: 0.9rem;
        }

        label {
            height: 1rem;
            font-size: 0.875rem;
        }
    }
  }
}
</style>